import { Button, ModalWindow, Textarea } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackCloseOfferNote, trackSaveOfferNote } from './tracking';
import { NoteModalLayout } from '../../components/NoteModalLayout';
import { useAppDispatch } from '../../hooks';
import { noteActions, selectIsNoteEditing, selectNoteOffer, selectNotePosition } from '../../slices';
import { EUpdateNoteAction, updateOfferNote } from '../../thunks';

export const NoteModalContainer = () => {
  const [note, setNote] = React.useState<string>('');

  const dispatch = useAppDispatch();

  const isEditing = useSelector(selectIsNoteEditing);
  const offer = useSelector(selectNoteOffer);
  const position = useSelector(selectNotePosition);

  const handleChangeNote = React.useCallback((_: never, value: string) => {
    setNote(value);
  }, []);

  const handleSaveNote = React.useCallback(() => {
    dispatch(updateOfferNote({ action: EUpdateNoteAction.Save, text: note, offer }));
    trackSaveOfferNote(offer?.id, position);
  }, [dispatch, note, offer, position]);

  const handleCloseEditing = React.useCallback(() => {
    dispatch(noteActions.reset());
    setNote('');
    trackCloseOfferNote(offer?.id, position);
  }, [dispatch, offer?.id, position]);

  React.useEffect(() => {
    const offerNote = offer?.notes?.offer?.text;

    if (offerNote) {
      setNote(offerNote);
    }
  }, [offer]);

  return (
    <ModalWindow open={isEditing} onClose={handleCloseEditing} title="Комментарий к объявлению">
      <NoteModalLayout
        textarea={<Textarea onChange={handleChangeNote} value={note} minRows={3} />}
        buttons={
          <>
            <Button onClick={handleSaveNote} size="XS" disabled={!note}>
              Сохранить
            </Button>
            <Button onClick={handleCloseEditing} size="XS" theme="fill_secondary">
              Отменить
            </Button>
          </>
        }
      />
    </ModalWindow>
  );
};
